import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BANNER_HEIGHT } from 'common/components/trial-page/trial-banner/style';

interface StyledWrapperProps {
  isTrialEnabled?: boolean;
}

export const StyledWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTrialEnabled',
})<StyledWrapperProps>(({ isTrialEnabled }) => ({
  display: 'flex',
  width: '100%',
  height: isTrialEnabled ? `calc(100vh - ${BANNER_HEIGHT})` : '100vh',
  backgroundColor: '#EBF0F5',
  position: 'fixed',
}));

export const ProgressWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
}));
